module.exports = __webpack_public_path__ + "img/select.94626449.svg";